import type { CartLineIssue } from "./orders";

/**
 * i18n descriptor for a server readiness issue (apps/orders/readiness.py).
 * Returns null for unknown codes — render the server's own message then.
 * One mapping shared by the cart and the order composer, so both entry
 * points explain a blocked send in exactly the same words (audit OE-A13).
 */
export function issueDescriptor(
  iss: CartLineIssue,
): { key: string; values?: Record<string, string | number> } | null {
  switch (iss.code) {
    case "PRICE_MISSING":
      return { key: "orders.issue.priceMissing" };
    case "BELOW_MOQ":
      return { key: "orders.issue.belowMoq", values: { min: iss.min ?? 1 } };
    case "NOT_PACKAGE_MULTIPLE":
      return { key: "orders.issue.notPackageMultiple", values: { multiple: iss.multiple ?? 1 } };
    case "OUT_OF_STOCK":
      return { key: "orders.issue.outOfStock", values: { available: iss.available ?? 0 } };
    case "NOT_ORDERABLE":
      return { key: "orders.issue.notOrderable" };
    case "NOT_ACCESSIBLE":
      return { key: "orders.issue.notAccessible" };
    case "EXPIRY_OFFER_GONE":
      return { key: "orders.issue.expiryGone" };
    case "EXPIRY_OFFER_SHORT":
      return { key: "orders.issue.expiryShort", values: { available: iss.available ?? 0 } };
    case "LOT_GONE":
      return { key: "q.issue.LOT_GONE" };
    case "LOT_SHORT":
      return { key: "q.issue.LOT_SHORT", values: { available: iss.available ?? 0 } };
    default:
      return null;
  }
}
